export default __webpack_public_path__ + "pin.0b492657.svg";